module.exports = __webpack_public_path__ + "img/37509-035.deb6854e.jpg";